// OpenAI (ChatGPT Ads) measurement pixel helpers.
// The pixel SDK is loaded in app/layout.tsx <head> and exposes a global
// `oaiq` queue function. Event data uses integer minor units (cents) per
// OpenAI's spec: https://developers.openai.com/ads/measurement-pixel

type OaiEventData = {
  type: "contents" | "customer_action" | "plan_enrollment" | "custom";
  amount?: number;
  currency?: string;
  contents?: Array<{
    id: string;
    name?: string;
    content_type?: string;
    quantity?: number;
  }>;
  plan_id?: string;
};

type OaiEventOptions = {
  event_id?: string;
  custom_event_name?: string;
};

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

export function oaiMeasure(
  eventName: string,
  data: OaiEventData,
  options?: OaiEventOptions
): void {
  try {
    if (typeof window === "undefined" || typeof window.oaiq !== "function") return;
    window.oaiq("measure", eventName, data, options);
  } catch {
    // analytics must never break the UI
  }
}

// Session-scoped one-shot guard so a conversion never fires twice for the
// same checkout (page reload, React StrictMode double-effect).
export function oaiFireOnce(key: string): boolean {
  try {
    if (typeof window === "undefined") return false;
    const storageKey = `oai_${key}`;
    if (window.sessionStorage.getItem(storageKey)) return false;
    window.sessionStorage.setItem(storageKey, "1");
    return true;
  } catch {
    return false;
  }
}
